export enum WIDGET {
  WEB_WIDGET = 'webWidget',
  MESSENGER = 'messenger',
}

export enum WIDGET_TYPE {
  CLASSIC = 'classic',
  MESSENGER = 'messenger',
}
